import config from './config';
import ConfigConstants from './constants';
import ProxiedConfigConstants from './proxiedConfig';

export default config;
export { ConfigConstants, ProxiedConfigConstants };
